module.exports = "https://r.nearpod.com/assets/media/image/checkbox-4dae1d5d7207bd8ce0c578804cb9200f.svg";